import { useEffect, useState } from "react"
function TourPopUp() {

    const [language, setLanguage] = useState('hindi')
    const [showing, setShowing] = useState(false)

    function close() {
        document.querySelector('.tourPopUp').classList.remove('popUp')
        document.querySelector('.tourPopUp').classList.add('d-none')
        setShowing(false)
    }

    useEffect(() => {
        try {
            const saved = JSON.parse(localStorage.getItem('ahtourp#1')) || null
            const tour = saved ? { ...saved, date: new Date(saved.date) } : { count: 0, date: new Date() }

            const diffTime = Math.abs(new Date() - tour.date);
            // convert milliseconds to days
            const diffDays = diffTime / (1000 * 60 * 60 * 24);

            if (tour.count < 1) {
                const timeout = setTimeout(() => {
                    document.querySelector('.tourPopUp').classList.remove('d-none')
                    document.querySelector('.tourPopUp').classList.add('popUp')
                    localStorage.setItem('ahtourp#1', JSON.stringify({ count: tour.count + 1, date: new Date() }))
                    setShowing(true)
                }, 10000)

                return () => clearTimeout(timeout)
            }
            else if (diffDays > 5) {
                const timeout = setTimeout(() => {
                    document.querySelector('.tourPopUp').classList.remove('d-none')
                    document.querySelector('.tourPopUp').classList.add('popUp')
                    localStorage.setItem('ahtourp#1', JSON.stringify({ 'count': 0, 'date': new Date() }))
                    setShowing(true)
                }, 10000)

                return () => clearTimeout(timeout)

            }
        }
        catch (error) {

        }
    }, [])


    useEffect(() => {
        const gotit = document.querySelector('.gotit')
        if (showing && gotit) {
            const timeout = setTimeout(() => {
                gotit.classList.remove('d-none')
                gotit.classList.add('d-block')
            }, 1000)

            return () => clearTimeout(timeout)
        }
    }, [showing])

    return (
        <div className='tourPopUp d-none'>
            <div className='box pt-1 pb-1' style={language === 'hindi' ? { fontSize: '16.8px', lineHeight: '1.65' } : { fontSize: '15.8px' }}>
                {
                    language === 'hindi' ?
                        <>
                            {/* <div className='pcolor h6 hi'>{app_name} पर आपका स्वागत है ❣️</div> */}
                            <div className="text-center hi h5 shining">महत्वपूर्ण सूचना</div>

                            <div className="mt-1 mb-1 text-start hi">
                                {/* हम एक छोटी सी टीम हैं, जिनका दिल से मकसद है कि <span className={language === 'hindi' && 'hi'}>परंपरा और शान की पहचान – महेश्वरी साड़ियाँ, सूट</span> पूरे भारत के घर-घर तक पहुँचें। हमारी वेबसाइट पर आपको हर उत्पाद (Product) की पूरी जानकारी मिलती है — <span className={language === 'hindi' && 'hi'}>कीमत, स्टॉक, रंग, ग्राहक रेटिंग और कई तस्वीरें</span> — ताकि आप घर बैठे ही निश्चिंत होकर खरीदारी कर सकें। */}
                                हम एक छोटी सी टीम हैं, जिनका दिल से मकसद है कि <span>परंपरा और शान की पहचान – महेश्वरी साड़ियाँ, सूट</span> पूरे भारत के घर-घर तक पहुँचें। हमारा उद्देश्य है कि आपकी खरीदारी का अनुभव आसान और सुखद हो — ताकि आप हमारे कलेक्शन को निश्चिंत होकर, <span>घर बैठे ही आसानी देख और पसंद कर सकें</span>।
                            </div>

                            <div className="text-start hi">
                                {/* कभी-कभी वेबसाइट पर फोटो अपलोड करते समय तस्वीरें हल्की-सी <span className={language === 'hindi' && 'hi'}>धुंधली या कम क्वालिटी</span> की हो सकती हैं। अगर कोई फोटो आपको साफ़ न लगे🥺, या आप और अच्छे से देखना चाहें🤔, तो कृपया🙏 हमें मैसेज या कॉल करें। हम खुशी से आपको <span className={language === 'hindi' && 'hi'}> प्रोडक्ट की अतिरिक्त तस्वीरें, छोटा वीडियो भेजेंगे या लाइव वीडियो कॉल</span> के ज़रिए प्रोडक्ट दिखाएँगे। <br />
                                आपकी संतुष्टि ही हमारी सबसे बड़ी खुशी है😊 — हम चाहते हैं कि आपको वही मिले जो आप पसंद करें। */}
                                हम समझते हैं कि केवल तस्वीरें देखकर हमेशा यह साफ़ अंदाज़ा लगाना आसान नहीं होता कि पहनने पर प्रोडक्ट कैसा दिखेगा। कभी-कभी अपलोड के दौरान तस्वीरें हल्की-सी धुंधली या थोड़ी कम क्वालिटी की भी हो सकती हैं। इसलिए हम हमेशा तैयार रहते हैं कि आपको <span>प्रोडक्ट की अतिरिक्त तस्वीरें, एक छोटा वीडियो, या फिर लाइव वीडियो कॉल के ज़रिए प्रोडक्ट और करीब से दिखाएँ</span>— ताकि आप पूरे भरोसे के साथ ख़रीदारी कर सकें। आपकी संतुष्टि ही हमारी सबसे बड़ी खुशी है 😊 — हम बस चाहते हैं कि आपको वही मिले जो आपको पसंद आए और जिससे आप खुश हों।
                            </div>

                            <div className="mt-1 mb-1 text-start hi">
                                अंत में ! अगर कभी आपको वेबसाइट पर कोई दिक़्क़त आये, कुछ समझ न आए 🤔 या किसी प्रोडक्ट को और अच्छे से देखना चाहते हो, तो बेझिझक 🙏।
                                {/* और अगर कभी वेबसाइट पर आपको दिक्कत आए, कोई सवाल हो🤔 या कुछ समझ न आए — तो बेझिझक🙏 */}
                            </div>

                            <div className="pcolor hi">हमें सीधे कॉल या व्हाट्सएप पर मैसेज करें किसी भी समय - 6260829322</div>

                            <div className="h7 text-center mt-1 hi">हम हर कदम पर आपकी मदद के लिए तैयार हैं 😊😇</div>
                        </>
                        :
                        <>
                            {/* <div className='pcolor h7 mb-1'>Welcome to {app_name} ❣️</div> */}
                            <div className="text-center h5 shining">Important Information</div>

                            <div className="mt-1 mb-2  text-start">
                                We are a small team on a heartfelt mission to bring authentic <span>Maheshwari textiles</span> to homes across the country. Our aim is to make your <span>shopping experience smooth and easy </span>— so you can explore our collection with confidence, right from the <span>comfort of your home</span>.
                                {/* We are a small team on a heartfelt mission to bring authentic <span>Maheshwari textiles</span> to homes across the country. Our listings show — price, stock, color, customer ratings, and multiple images — so you can shop confidently from the <span className={language === 'hindi' && 'hi'}>comfort of your home</span>. */}
                            </div>

                            <div className=" text-start">
                                We understand that pictures alone may not always give a clear idea of how a product will look when worn. Also Sometimes images can also appear slightly compressed or blurred during upload. That’s why we’re always happy to share extra photos, a short product video, or even arrange a live video call — so you can see the product more closely before you buy. Your satisfaction is our greatest joy — we simply want you to be happy with what you receive 😊.
                                {/* Sometimes images uploaded to the website may become slightly compressed or look a little blurred during upload. If an image doesn’t give you the confidence you need🥺, or if you’d like a closer look🤔, then please🙏 message us or call us directly — we will gladly <span className={language === 'hindi' && 'hi'}>send extra photos, a short product video, or arrange a live video call</span> so you can inspect the product closely before you buy. Your satisfaction is our greatest joy😊 — we just want you to be happy with what you receive. */}
                            </div>

                            <div className=" mt-2 mb-2 text-start">
                                At last, if you ever get stuck on the website? don’t understand something? or you’d like a closer look of any product then please🙏 don’t hesitate to reach out 🙏.
                            </div>

                            <div className=" pcolor h7">Directly Call us or Whatsapp us anytime - 6260829322</div>

                            <div className="smallText text-center mt-2">We are here to help you at every step 😊😇</div>

                        </>
                }

                <div className="d-flex gap-4 mt-1 mb-2">
                    <button className="secondryButton mb-0 h7 hi" onClick={() => setLanguage('hindi')}>हिंदी में देखें</button>
                    <button className="secondryButton mb-0 h7" onClick={() => setLanguage('english')}>English</button>
                    <button className="primaryButton mt-1 mb-0 h7 d-none gotit" onClick={() => close()}>{language === 'hindi' ? 'ठीक है' : 'Got It'}</button>
                </div>
            </div>
        </div>
    )
}

export default TourPopUp